import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { BadgeCountPipe } from './badge-count/badge-count.pipe'
import { ChangeCasePipe } from './change-case/change-case.pipe'
import { CorrectUrlPipe } from './correct-url/correct-url.pipe'
import { CurrencyFormatPipe } from './currency-format/currency-format.pipe'
import { FormatDocumentNumberPipe } from './document-number-format/document-number-format.pipe'
import { GetControlPipe } from './get-control/get-control.pipe'
import { IsBase64Pipe } from './is-base64/is-base64.pipe'
import { MapPipe } from './map/map.pipe'
import { PhonePipe } from './phone/phone.pipe'
import { TranslateAuditLogEventPipe } from './translate-audit-log-event/translate-audit-log-event.pipe'
import { TranslateExportTypePipe } from './translate-export-type/translate-export-type.pipe'
import { TranslateProductMeasurePipe } from './translate-product-measure/translate-product-measure.pipe'
import { TranslateProductServiceValueTypePipe } from './translate-product-service-value-type/translate-product-service-value-type.pipe'
import { TranslateStorageMovementTypePipe } from './translate-storage-movement-type/translate-storage-movement-type.pipe'
import { TranslateStorageProductStatusPipe } from './translate-storage-product-status/translate-storage-product-status.pipe'
import { TranslateTicketStatusPipe } from './translate-ticket-status/translate-ticket-status.pipe'
import { TranslateWarrantyStatusPipe } from './translate-warranty-status/translate-warranty-status.pipe'

@NgModule({
  declarations: [
    BadgeCountPipe,
    ChangeCasePipe,
    CorrectUrlPipe,
    CurrencyFormatPipe,
    FormatDocumentNumberPipe,
    GetControlPipe,
    IsBase64Pipe,
    MapPipe,
    PhonePipe,
    TranslateAuditLogEventPipe,
    TranslateExportTypePipe,
    TranslateProductMeasurePipe,
    TranslateProductServiceValueTypePipe,
    TranslateStorageMovementTypePipe,
    TranslateStorageProductStatusPipe,
    TranslateTicketStatusPipe,
    TranslateWarrantyStatusPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    BadgeCountPipe,
    ChangeCasePipe,
    CorrectUrlPipe,
    CurrencyFormatPipe,
    FormatDocumentNumberPipe,
    GetControlPipe,
    IsBase64Pipe,
    MapPipe,
    PhonePipe,
    TranslateAuditLogEventPipe,
    TranslateExportTypePipe,
    TranslateProductMeasurePipe,
    TranslateProductServiceValueTypePipe,
    TranslateStorageMovementTypePipe,
    TranslateStorageProductStatusPipe,
    TranslateTicketStatusPipe,
    TranslateWarrantyStatusPipe
  ],
  providers: [
    BadgeCountPipe,
    ChangeCasePipe,
    CorrectUrlPipe,
    CurrencyFormatPipe,
    FormatDocumentNumberPipe,
    GetControlPipe,
    IsBase64Pipe,
    MapPipe,
    PhonePipe,
    TranslateAuditLogEventPipe,
    TranslateExportTypePipe,
    TranslateProductMeasurePipe,
    TranslateProductServiceValueTypePipe,
    TranslateStorageMovementTypePipe,
    TranslateStorageProductStatusPipe,
    TranslateTicketStatusPipe,
    TranslateWarrantyStatusPipe
  ]
})
export class PipesModule { }
